// extracted by mini-css-extract-plugin
export default {"container":"section_container__q4eUr","title":"section_title__VfDKr","header":"section_header__S0S4B","description":"section_description__xyttR","item":"section_item__1kfJs"};